import { Component } from "react";

const RELOAD_KEY = "ccs_eb_reload_at";
const LOOP_WINDOW_MS = 8000; // if it errors again within this window, stop auto-reloading

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, recovering: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App render error:", error, info);
    let recovering = false;
    try {
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      const now = Date.now();
      // Auto-recover with a single reload, unless we just reloaded (prevents loops).
      if (now - last > LOOP_WINDOW_MS) {
        sessionStorage.setItem(RELOAD_KEY, String(now));
        recovering = true;
        window.location.reload();
      }
    } catch (e) {
      /* ignore */
    }
    this.setState({ recovering });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.routeKey !== this.props.routeKey && this.state.hasError) {
      this.setState({ hasError: false, recovering: false });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.recovering) {
        return (
          <div className="pt-52 pb-52 text-center px-5" data-testid="error-recovering">
            <div className="mx-auto h-10 w-10 rounded-full border-2 border-line border-t-roast animate-spin" />
            <p className="text-muted-foreground mt-6 text-sm">Se reîncarcă pagina...</p>
          </div>
        );
      }
      return (
        <div className="pt-40 pb-40 text-center px-5" data-testid="error-boundary">
          <h1 className="font-display text-4xl md:text-5xl tracking-tight">Ceva n-a mers bine</h1>
          <p className="text-muted-foreground mt-4">Te rugăm reîncarcă pagina. Ne cerem scuze pentru inconveniență.</p>
          <button
            onClick={() => {
              try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) { /* ignore */ }
              window.location.reload();
            }}
            data-testid="error-reload"
            className="mt-8 bg-ink text-cream px-8 py-4 text-sm font-semibold hover:bg-roast transition-colors"
          >
            Reîncarcă pagina
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
